import { Radio } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';

import type { ViewSettings as TViewSettings } from 'src/api/chart/drilling-plan-charts-api';
import Collapse, { Panel } from 'src/shared/components/collapse/collapse';

import type { EditingSettingsItem } from '../../shared/editing-settings-item';

type Props = {
  settings: TViewSettings.FlatSettingsControls;
};

const SystemSettingsBlock = observer<PropsWithChildren<{ group: TViewSettings.GroupedSettingsControlsGroupData }>>(
  function SystemSettingsBlock({ children, group }) {
    const [activeKey, setActiveKey] = useState<string[]>(['systemSettings']);

    const handleChange = (key: string | string[]) => {
      setActiveKey(Array.isArray(key) ? key : [key]);
    };

    return (
      <Collapse key="systemSettings" activeKey={activeKey} onChange={handleChange} bordered>
        <Panel
          key="systemSettings"
          style={{
            marginTop: '-16px',
            '--collapse-border-color': 'transparent',
          }}
          header={
            <p
              style={{
                color: 'var(--go-text-50)',
              }}
              className="body-m"
            >
              {group.title}
            </p>
          }
        >
          {children}
        </Panel>
      </Collapse>
    );
  },
);

const UserSettingsBlock = observer<PropsWithChildren<{ group: TViewSettings.GroupedSettingsControlsGroupData }>>(
  function UserSettingsBlock({ children, group }) {
    return (
      <div
        key={group.fieldId}
        style={{
          paddingBottom: '16px',
          borderBottom: '1px solid var(--collapse-border-color)',
        }}
      >
        <p
          style={{
            color: 'var(--go-text-50)',
            paddingBottom: '16px',
          }}
          className="body-m"
        >
          {group.title}
        </p>
        {children}
      </div>
    );
  },
);

export const ColorSettings = observer<Props>(function ColorSettings({ settings }) {
  // Самый простой и стабильный способ синхронизировать состояние радио-кнопок с состоянием items
  const handleChange = (selectedItem: EditingSettingsItem) => {
    settings.items.forEach((item) => {
      if (item === selectedItem) {
        item.setIsShown(true);
      } else {
        item.setIsShown(false);
      }
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {settings.items.map((item) => {
        return (
          <div key={item.id}>
            <Radio checked={item.isShown} onChange={() => handleChange(item)} value={item.id}>
              {item.title}
            </Radio>
          </div>
        );
      })}
    </div>
  );
});
